import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Checkbox, Select, DatePicker, Input, Button, Row, Col, message } from 'antd';
import InfiniteScroll from 'react-awesome-infinite-scroll';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import api from '@api/api';
import downIcon from '@assets/images/down_conner.svg'
import bigIcon from '@assets/images/big_icon.svg'



const SkuItem = (props) => {
    const { getSelectids, item, selectIDs, isSelected, downoncePic } = props

    const onChange = (id) => {
        getSelectids(id)
    };



    return (
        <div key={item.id} onClick={props.onClick} className={`${styles.SkuItem} ${item.deliverStatus == 1 && item.status != 0?styles.SkuItem_4: null}`}>
            <div className={`${styles.SkuItem_}
             ${item.status == 2 || item.status == 3?styles.SkuItem_1: null}
             ${item.status == 4?styles.SkuItem_3: null}
             ${item.status == 0 && item.deliverStatus == 1?styles.SkuItem_5: null}
             `}>
                <div className={styles.img_1_box}>
                    <img className={styles.img_1} src={item.displayImage + '?x-oss-process=image/resize,w_800/quality,q_90/format,webp'} alt="" />
                </div>
                {
                    isSelected ? <div className={styles.SkuItem_mask} onClick={() => onChange(item.id)}>
                        <Checkbox checked={selectIDs.includes(item.id)}></Checkbox>
                    </div> : null
                }
                <img onClick={(e) => downoncePic(e, item.id, item.deliverStatus)} className={styles.down_icon} src={downIcon} />
                <img className={styles.big_icon} src={bigIcon} />
            </div>
        </div>
    );
}

export default SkuItem